import { OrganizationsContainer } from './OrganizationsContainer';

const name = 'OrganizationsContainer';

export { OrganizationsContainer, name };
